import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import image1 from "../../../../shared/resources/ieee-mb-tagline-white.png";
import logoMalaysia from "../../../../shared/resources/Malaysia_logo_white_2021.png";
import logoSrilanka from "../../../../shared/resources/insl-logo-white-transparent.png";
import logoBosnia from "../../../../shared/resources/ieee-logo-bih-white.png";
import logoJamaica from "../../../../shared/resources/Jamaika-White-Flat.png";
import logoIndia from "../../../../shared/resources/india-logo.png";
import logoIndonesia from "../../../../shared/resources/Indonesia logo white-01.png";
import { Country } from "../../../../shared/constants/Constant";

interface IProps {
  country: Country;
}

const SidePanel = (props: IProps) => {
  const getRulesLink = (): string => {
    const baseUrl = "http://in.ieee.org/guidelines-";
    switch (props.country) {
      case Country.SRI_LANKA:
        return baseUrl + "srilanka";
      case Country.INDIA:
        return baseUrl + "india";
      case Country.MALAYSIA:
        return baseUrl + "malaysia";
      case Country.INDONESIA:
        return baseUrl + "indonesia";
      case Country.JAMAICA:
        return baseUrl + "jamaica";
      default:
        return baseUrl + "bih";
    }
  };
  const getTitle = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              Sri Lanka <br />
              2021
            </h1>
            <h2 style={{ fontSize: "20px" }}>Pre-Accelerator</h2>
          </>
        );
      case Country.INDIA:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              India <br />
            </h1>
            {/* <h2 style={{ fontSize: "20px" }}>Pre-Accelerator</h2> */}
          </>
        );
      case Country.MALAYSIA:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              Malaysia <br />
              2022
            </h1>
            <h2 style={{ fontSize: "20px" }}>Techno-preneurship Bootcamp</h2>
          </>
        );
      case Country.INDONESIA:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              Indonesia <br />
              2021
            </h1>
            <h2 style={{ fontSize: "20px" }}>Techno-preneurship Bootcamp</h2>
          </>
        );
      case Country.JAMAICA:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              Jamaica <br />
              2020
            </h1>
          </>
        );
      default:
        return (
          <>
            <h1 style={{ fontSize: "30px" }}>
              IEEE <br />
              Innovation Nation <br />
              Bosnia & Herzegovina <br />
              2020
            </h1>
          </>
        );
    }
  };
  const getImage = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return (
          <img
            src={logoSrilanka}
            alt=""
            style={{
              width: "120px",
              transform: "translateY(-15px)",
            }}
          />
        );
      case Country.MALAYSIA:
        return (
          <img
            src={logoMalaysia}
            alt=""
            style={{
              width: "200px",
              transform: "translateY(-20px) translateX(-20px) ",
            }}
          />
        );
      case Country.INDONESIA:
        return (
          <img
            src={logoIndonesia}
            alt=""
            style={{
              width: "200px",
              transform: "translateY(-55px) translateX(-20px) ",
            }}
          />
        );
      case Country.JAMAICA:
        return (
          <img
            src={logoJamaica}
            alt=""
            style={{
              width: "190px",
              transform: "translateY(-15px) translateX(0px) ",
            }}
          />
        );
      case Country.INDIA:
        return (
          <img
            src={logoIndia}
            alt=""
            style={{
              width: "220px",
              transform: "translateY(-10px) translateX(-10px) ",
            }}
          />
        );
      default:
        return (
          <img
            src={logoBosnia}
            alt=""
            style={{
              width: "140px",
              transform: "translateY(-28px) translateX(-10px) ",
            }}
          />
        );
    }
  };

  return (
    <div style={{ padding: "50px", color: "#fff" }}>
      {getTitle()}
      <div className="mt-4">
        <p className="text-justify" style={{ fontSize: "14px" }}>
          If you'd like to be considered for the Innovation Nation program then
          please complete this form, giving as much information as possible.
        </p>
        {props.country === Country.BOSNIA ? (
          <>
            <p className="text-justify" style={{ fontSize: "14px" }}>
              Please ensure you are familiar with all the:
            </p>
            <ol
              className="text-justify list-unstyled"
              style={{ fontSize: "14px" }}
            >
              <li>1. Expectations and requirements of participants</li>
              <li>2. Rules and guidelines</li>
              <li>3. Time commitment and rewards</li>
            </ol>
          </>
        ) : (
          <p className="text-justify" style={{ fontSize: "14px" }}>
            We help you work through your business model hand in hand with
            expert advise rounded out with hands-on support and mentoring from
            our awesome and dedicated mentors and connect you to the right
            people to finance and accelerate your startup growth.
          </p>
        )}
        {props.country === Country.BOSNIA ? (
          <p className="text-justify" style={{ fontSize: "14px" }}>
            Please read the{" "}
            <a
              href={getRulesLink()}
              rel="noopener noreferrer"
              target={"_blank"}
              style={{ color: "yellow" }}
            >
              competition rules and guidelines
            </a>{" "}
            before filling the application.
          </p>
        ) : props.country !== Country.INDIA ? (
          <p className="text-justify" style={{ fontSize: "14px" }}>
            Please read the competition rules and guidelines posted in{" "}
            <a
              href={getRulesLink()}
              rel="noopener noreferrer"
              target={"_blank"}
              style={{ color: "yellow" }}
            >
              competition rules and guidelines
            </a>{" "}
            before filling the application.
          </p>
        ) : (
          <></>
        )}
      </div>
      <Container fluid className="pt-3">
        <Row>
          <Col className="pl-0">{getImage()}</Col>
          <Col className="pr-0 text-right">
            <img src={image1} alt="" style={{ width: "140px" }} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SidePanel;
